module.exports = __webpack_public_path__ + "img/Butterfly_00286.f94990bf.png";